<input
  class="w-100"
  [ngClass]="class"
  [type]="type"
  nz-input
  [placeholder]="getPlaceholder()"
  [formControl]="control"
  [minlength]="min"
  [maxlength]="max"
  [readonly]="readonly"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
/>
